{
  "settings": "Nastavenia",
  "yourDigitalAssistant": "Váš digitálny asistent",
  "getStarted": "Začíname",
  "login": "Prihlásenie",
  "loggingIn": "Prihlásenie ...",
  "darkMode": "Tmavý režim",
  "clearHistory": "Vymazať históriu",
  "historyCleared": "História vymazaná",
  "changeLanguage": "Jazyk",
  "termsAndConditions": "Podmienky používania",
  "messagePlaceholder": "Sem napíšte svoju správu ...",
  "messagePlaceholderDisabled": "Písanie zakázané ...",
  "feedbackTitle": "Ohodnoťte svoju skúsenosť",
  "feedbackPlaceholder": "Povedzte nám o tom (voliteľné)",
  "feedbackSend": "Odoslať",
  "feedbackClose": "Zavrieť",
  "sessionExpired": "Platnosť vašej relácie vypršala kvôli neaktivite.",
  "startNewSession": "Spustiť novú reláciu",
  "apiError": "Ojoj! Niečo sa pokazilo. Pracujeme na tom, aby sme to napravili čo najskôr.",
  "apiErrorOffline": "Nie ste pripojení k internetu.",
  "tryAgain": "Skúste to znova",
  "startOver": "Začať odznova",
  "chatEnded": "Chat sa skončil.",
  "chatEndedThankYou": "Ďakujeme, že ste s nami chatovali!",
  "closeChat": "Zavrieť",
  "startNewChat": "Znova chatovať",
  "humanTakeoverStarted": "Teraz sa presúvate do zákazníckeho servisu ...",
  "humanTakeoverQueued": "Čaká sa na pripojenie k agentovi",
  "humanTakeoverAnAgent": "Agent",
  "humanTakeoverAgentEntered": "vstúpil do konverzácie",
  "humanTakeoverAgentLogout": "opustil konverzáciu",
  "humanTakeoverTransfer": "Prechádzate k novému agentovi",
  "humanTakeoverEnded": "Teraz chatujete so svojím digitálnym asistentom",
  "version": "Verzia",
  "formIntroText": "Prosím, vyplňte nasledujúci formulár, aby ste s nami začali chatovať.",
  "formFirstName": "Meno",
  "formLastName": "Priezvisko",
  "formName": "Name",
  "formEmail": "E-mail",
  "formWrongEmail": "Zadajte platnú e-mailovú adresu.",
  "formPhone": "Telefón",
  "formShipmentId": "ID zásielky",
  "formQuestion": "Vaša otázka",
  "formAccountNumber": "Číslo účtu (pre obchodných zákazníkov)",
  "formAddress": "Adresa",
  "formPostcode": "PSČ",
  "formCity": "Mesto",
  "formCountry": "Krajina",
  "formSubmitButton": "Začať chat",
  "formEmptyFieldError": "Nesmie byť prázdny.",
  "formPhoneNumberValidationError": "Neplatné telefónne číslo.",
  "formInputIsBiggerThan50": "Musí mať najviac 50 znakov.",
  "formInputIsBiggerThan100": "Musí mať najviac 100 znakov.",
  "formInputIsBiggerThan2000": "Musí mať najviac 2 000 znakov.",
  "widgetEventOnline": "DA správa: Používateľ je späť online.",
  "widgetEventHidden": "DA správa: Widget je skrytý.",
  "widgetEventVisible": "DA správa: Widget je viditeľný.",
  "widgetEventVisibleMinimized": "DA správa: Widget je viditeľný, ale minimalizovaný.",
  "widgetEventMinimized": "DA správa: Widget je minimalizovaný.",
  "widgetEventMaximized": "DA správa: Widget je maximalizovaný.",
  "widgetEventSessionExpired": "DA správa: Platnosť relácie widgetu vypršala.",
  "widgetEventHangupHuman": "Správa DA: Užívateľská relácia osobného prevzatia.",
  "widgetEventUserTyping": "DA správa: používateľ píše.",
  "fileTooLarge": "Pokúšate sa pripojiť príliš veľké súbory.",
  "tooManyDiles": "Pokúšate sa pripojiť príliš veľa súborov.",
  "fileInvalidType": "Pokúšate sa pripojiť neplatné typy súborov.",
  "attachmentsDropHere": "Sem pustite upload alebo",
  "attachmentsBrowse": "Prehliadajte súbory",
  "attachmentsExtenstionQuantity": "pdf alebo obrázky (až 10 súborov)",
  "attachmentsSize": "do 30 MB",
  "attachmentsFailedUploading": "Nahrávanie zlyhalo",
  "attachmentsUploading": "Nahrávanie ...",
  "minimizeExpandText": "Klepetajte v živo z nami zdaj!",
  "popupWidgetNotificationMessage": "Prejeli ste novo sporočilo!",
  "tabWidgetNotificationMessage": "Novo sporočilo!",
  "datepickerSendButton": "Pošlji"
}
